import { inject } from '@angular/core';
import {
  HttpErrorResponse,
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
} from '@angular/common/http';
import { AES, enc, mode, pad } from 'crypto-js';
import { Router } from '@angular/router';
import { catchError, map, throwError } from 'rxjs';
import { AutenticacaoService } from '../api/autenticacao/autenticacao.api';
import { AvisoService } from '../service/aviso/aviso.service';
import { BaseResponse } from '../models/response/base-response';
import { BYPASS_AUTH } from '../service/upload-documento/upload-documento.service';

export const AutenticacaoInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
) => {
  const autenticacaoService = inject(AutenticacaoService);
  const avisoService = inject(AvisoService);
  const router = inject(Router);
  const token = localStorage.getItem('token');

  if (req.context.get(BYPASS_AUTH)) {
    return next(req);
  }

  let modifiedReq = req;
  if (req.url.endsWith('/Login') && req.body) {
    const key = enc.Utf8.parse('sJgppTL83sr1HILcta0LX0yEMJUo8qs3');
    const iv = enc.Utf8.parse('HR$2pIjHR$2pIj12');

    const plainText = typeof req.body == 'string' ? req.body : JSON.stringify(req.body);
    const encrypted = AES.encrypt(plainText, key, {
      iv,
      mode: mode.CBC,
      padding: pad.Pkcs7,
    }).toString();

    modifiedReq = req.clone({
      body: { encrypted },
      withCredentials: true,
      setHeaders: { Accept: 'application/json' },
    });
  }
  else if (token) {
    modifiedReq = req.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    });
  }

  return next(modifiedReq).pipe(
    map((event: any) => {
      if (event?.body && typeof event.body.status == 'boolean') {
        const response = event.body as BaseResponse<any>;

        if (response.semPermissao) {
          avisoService.Info('Você não tem permissão para acessar essa página!');
          router.navigate(['/Dashboard']);
        }
      }
      return event;
    }),
    catchError((erro: HttpErrorResponse) => {
      if (erro.status == 401) {
        autenticacaoService.Logout();
        router.navigate(['/'])
      }
      return throwError(() => erro);
    })
  );
};
